import { render, staticRenderFns } from "./PopUpDirectly.vue?vue&type=template&id=0adbf4e2"
import script from "./PopUpDirectly.vue?vue&type=script&lang=js"
export * from "./PopUpDirectly.vue?vue&type=script&lang=js"
import style0 from "./PopUpDirectly.vue?vue&type=style&index=0&id=0adbf4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports